import { ApiToken } from "types/apiToken.type";
import { CompanySettings } from "types/companySettings.type";

export type Company = {
  id: number;
  uuid: string;
  name: string;
  organizationNumber: string;
  contactFullName: string;
  contactPhone: string;
  contactEmail: string;
  logoUrl?: string;
  certificateLogoUrl?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  isInvoicingEnabled: boolean;
  apiTokens?: ApiToken[];
  settings: CompanySettings;
  operatorPrivileges: OperatorPrivileges;
  isNorva: boolean;
};

export type OperatorPrivileges = {
  viewCustomerList: boolean;
  addCustomer: boolean;
  viewCustomer: boolean;
  editCustomer: boolean;
  addFacility: boolean;
  viewFacility: boolean;
  editFacility: boolean;
  addSeparator: boolean;
};

export enum OperatorPrivilege {
  ViewCustomerList = "viewCustomerList",
  AddCustomer = "addCustomer",
  ViewCustomer = "viewCustomer",
  EditCustomer = "editCustomer",
  AddFacility = "addFacility",
  ViewFacility = "viewFacility",
  EditFacility = "editFacility",
  AddSeparator = "addSeparator",
}
